<template>
  <v-ons-page>
  </v-ons-page>
</template>
<script>
import { Auth } from '@/utils/auth'

export default {
  name: 'login-page',
  methods: {
    encodeDataToURL (data) {
      return Object
        .keys(data)
        .map(value => `${value}=${encodeURIComponent(data[value])}`)
        .join('&');
    },
    getTokenFromParams () {
      const parsedParams = {};
      this.$route.hash.split('&')
      .map(part => part.replace(/#/, ''))
      .forEach(param => {
        console.log(param)
        const parts = param.split('=');
        parsedParams[parts[0]] = parts[1];
      })
      return parsedParams['id_token']
    }
  },
  mounted() {
    console.log(this.$route)
    console.log(window.location)
    if (!_.isEmpty(this.$route.hash)) {
      if ( Auth.login(this.getTokenFromParams())) {
        window.location.href = '/'
      } else {
        this.$toasted.error('Oh non :( votre accès semble être incorrect')
      }
    } else {
      let params = {redirect_uri: window.location.href,
                    client_id: process.env.VUE_APP_AIO_CONNECT_CLIENT_ID,
                    response_type: 'id_token',
                    nonce: 'waluigithewinner'}
      window.location = process.env.VUE_APP_AIO_CONNECT_URL + "auth?" + this.encodeDataToURL(params)
    }
  }
  // eslint-disable-next-line
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// LoginPage.vue?70e75317